import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { CustomReportsService } from '@/infra/services/custom-reports';

interface GetCustomReportByTypeListParams {
	organization_id: string;
	company_id: string;
	custom_report_id: string;
	data_extraction_id?: string;
	sector_id?: string;
	line_id?: string;
	workstation_id?: string;
	min_rpn?: number;
	max_rpn?: number;
	start_date?: string;
	end_date?: string;
	offset?: number;
	limit?: number;
}

const Service = CustomReportsService.getInstance();

export function useGetCustomReportByTypeList(params: GetCustomReportByTypeListParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_CUSTOM_REPORT_BY_TYPE_LIST, params],
		queryFn: () => Service.getCustomReportByTypeList(params),
		enabled: !!params?.organization_id && !!params?.company_id && !!params?.custom_report_id
	});
}
